class CollectionSnippet extends HTMLElement {
	constructor() {
		super();

		this.placeholder = this.hasAttribute('placeholder');
		this.url = this.getAttribute('url');
		this.page = 1;

		this.addEventListener('pagechange', async e => {
			this.page = parseInt(e.detail.page);
			this.classList.add('loading');
			await this.refresh();
			this.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest'});
			this.classList.remove('loading');
		});
	}

	connectedCallback() {
		if (this.placeholder) this.refresh();
	}

	async refresh() {
		const url = new URL(this.url, document.location);
		url.searchParams.set('page', this.page);
		url.searchParams.set('view', 'snippet');

		const resp = await fetch(url);
		const parser = new DOMParser();
		const doc = parser.parseFromString(await resp.text(), 'text/html');
		const newSnippet = doc.querySelector('collection-snippet');
		this.innerHTML = newSnippet.innerHTML;
	}
};

customElements.define('collection-snippet', CollectionSnippet);

class CollectionSnippetPages extends HTMLElement {
	constructor() {
		super();

		for (const a of this.querySelectorAll('a')) {
			a.addEventListener('click', e => {
				e.preventDefault();
				const url = new URL(a.href);
				const page = url.searchParams.get('page');

				this.dispatchEvent(new CustomEvent('pagechange', {
					detail: { page: page },
					bubbles: true
				}));
			});
		}
	}
}

customElements.define('collection-snippet-pages', CollectionSnippetPages);